import { CopyOverlay } from '@/shared/components/CopyOverlay'

interface ShellSnippetProps {
  code: string
  language?: string
  fontSize?: string
}

export function ShellSnippet({ code, language, fontSize = '0.78rem' }: ShellSnippetProps) {
  return (
    <div style={{ position: 'relative' }}>
      {language && (
        <div style={{
          position: 'absolute', top: 8, left: 12,
          fontFamily: 'var(--mono)', fontSize: '0.58rem',
          color: 'var(--text3)', letterSpacing: '0.08em', textTransform: 'lowercase',
          pointerEvents: 'none',
        }}>
          {language}
        </div>
      )}
      <pre style={{
        fontFamily: 'var(--mono)',
        fontSize,
        lineHeight: 1.7,
        background: 'var(--bg4)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        padding: language ? '30px 16px 14px' : '14px 16px',
        margin: 0,
        overflowX: 'auto',
        textAlign: 'left',
        color: 'var(--text2)',
        whiteSpace: 'pre',
      }}>
        {code}
      </pre>
      <CopyOverlay value={code} label="Copy" />
    </div>
  )
}
